import { Box, Grid, Typography, Link, Paper, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { getCustomer, getTipologias } from "../../apis/backendRequests";
import { makeRequest } from "../../apis/makeRequest";
import { galleryActions } from "../../actions";
import { FaTiktok } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { isMaintenanceMode } from "../../helpers/maintenanceMode";

const styles = {
  footer: {
    backgroundColor: "white",
    borderTop: "1px solid #e0e0e0",
    padding: "1rem 1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "5px",
  },
  gridFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    minWidth: "200px"
  },
  gridFooterMobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: "200px"
  }
}


const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const [dataCategories, setDataCategories] = useState([]);
  const [tabs, setTabs] = useState({ nameTabs: [], categories: [] });

  const { brand } = useSelector((state) => state.gallery);
  const { isLoggedIn, dynamicsId, roles } = useSelector((state) => state.account);

  const allStr = "Todas";

  useEffect(() => {
    if (isMaintenanceMode || pathname === "/lista-cientes" || roles?.includes('Admin Ventas') || roles?.includes('Vendedor')) return
    makeRequest(
      () => getCustomer(isLoggedIn ? dynamicsId : "online"),
      (res) => {
        if (res.data.priceLevel) {
          makeRequest(
            () => getTipologias(res.data.priceLevel),
            (request) => { Object.keys(request.data).length > 0 && setDataCategories([{ name: allStr }, ...request.data]) },
            null,
            { checkEmptyResults: false }
          );
        }
      }
    );
  }, [brand, dynamicsId, isLoggedIn]);

  useEffect(() => {
    if (Object.keys(dataCategories).length !== 0) {
      const tab = dataCategories.reduce((ac, categoria) => {
        if (typeof categoria.categoriaDescription !== "undefined") {
          const tipo = categoria.categoriaDescription;
          if (!ac.hasOwnProperty(tipo)) {
            ac[tipo] = {};
          }
          const rubro = categoria.rubroDescription;

          if (!ac[tipo].hasOwnProperty(rubro)) {
            ac[tipo][rubro] = [];
          }
          ac[tipo][rubro].push(categoria);
        }
        return ac;
      }, {});

      const categoryNames = [...Object.keys(tab)].map(
        (label) => ({ label })
      );
      setTabs({ nameTabs: categoryNames, categories: tab });
    }
  }, [dataCategories]);

  const navigateCategory = (categoria) => {
    dispatch(galleryActions.setSearchTerm(""));
    dispatch(galleryActions.setCategoria(categoria));
    dispatch(galleryActions.setRubro(""));
    dispatch(galleryActions.setSubRubro(""));
    dispatch(galleryActions.setPromocion(""));
    navigate(isLoggedIn ? "/products" : "/catalogo");
  };


  const showExtendedFooter = isMaintenanceMode || (pathname !== "/products" && pathname !== "/catalogo" && pathname !== "/lista-clientes" && pathname !== "/menu" && !pathname.startsWith("/reportes"))

  if (showExtendedFooter)
    return (

      <Paper elevation={6} sx={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "4px", marginTop: isMobile ? "3rem" : "6rem", }}>
        <Grid container spacing={4} style={styles.footer}>
          {/* Links Sociales y Sitios */}
          <Grid item xs={12} style={isMobile ? styles.gridFooterMobile : styles.gridFooter}>
            <Box sx={{ display: "flex", gap: "8px", color: "black", alignItems: "center", justifyContent: "center" }}>
              <Typography textAlign="center" sx={{ fontWeight: "400", fontSize: "15px" }}>Siguenos en: </Typography>
              <a href="https://www.instagram.com/pizzini_argentina/" target="_blank" rel="noopener noreferrer"><FaInstagram style={{ fontSize: "18px", color: "black" }} /></a>
              <a href="https://www.facebook.com/PizziniArgentina" target="_blank" rel="noopener noreferrer"><FaFacebook style={{ fontSize: "18px", color: "black" }} /></a>
              <a href="https://www.youtube.com/channel/UCuE5ksQv9FcwaFYKFb1FxFQ" target="_blank" rel="noopener noreferrer"><FaYoutube style={{ fontSize: "18px", color: "black" }} /></a>
              <a href="https://www.tiktok.com/@pizziniargentina" target="_blank" rel="noopener noreferrer"><FaTiktok style={{ fontSize: "18px", color: "black" }} /></a>
            </Box>
            <Box display={"flex"}>
              <Link href="https://www.pizzini.com.ar" target="_blank" rel="noopener noreferrer" sx={{ fontSize: "13px", color: "#333", textDecoration: "none", marginLeft: "1rem", "&:hover": { color: "#000" }, }}>
                Pizzini.com.ar
              </Link>
              <Link href="https://www.encuentrodocente.com" target="_blank" rel="noopener noreferrer" sx={{ fontSize: "13px", color: "#333", textDecoration: "none", marginLeft: "1rem", "&:hover": { color: "#000" }, }}>
                Encuentrodocente.com
              </Link>
            </Box>
          </Grid>

          {!isMaintenanceMode && (
            <Grid item xs={12} style={{ display: "flex", justifyContent: "center", gap: "1.5rem" }}>
              {tabs.nameTabs.map((tab, i) => (
                <Typography key={i} sx={{
                  color: "#333", transition: "all 0.2s ease-in", fontWeight: "400",
                  fontSize: "12.5px", cursor: "pointer",
                  "&:hover": { color: "#000", fontWeight: "600", transition: "all 0.2s ease-out" },
                }} onClick={() => navigateCategory(tab.label)}>
                  {tab.label}
                </Typography>
              ))}
            </Grid>
          )}
          {/* Información de Contacto */}
          <Grid item xs={12} style={{ textAlign: "center", minWidth: "150px" }}>
            <Typography sx={{ fontWeight: "700", color: "#333" }}>
              Contáctenos
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "#666" }}>Francisco Laprida 3163 / 75 (B1603AAD)</Typography>
            <Typography sx={{ fontSize: "14px", color: "#666" }}>Edificio NODUS Villa Martelli</Typography>
            <Typography sx={{ fontSize: "14px", color: "#666" }}>Mail: portal@pizzini.com.ar</Typography>
            <Typography sx={{ fontSize: "14px", color: "#666" }}>Tel: (54 11) 5232-0797</Typography>
          </Grid>
        </Grid>
      </Paper>


    );
};

export default Footer;
